var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrations2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.5 15.5",
    style: {
      enableBackground: "new 0 0 15.5 15.5"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.integrations-2-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "integrations-2-svg",
    d: "M0.8,14.7l3.1-3.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "integrations-2-svg",
    d: "M5.8,0.8L3.9,2.7C2.7,3.8,2,5.5,2,7.1c0,1.7,0.7,3.3,1.9,4.5c1.2,1.2,2.8,1.9,4.5,1.9c1.7,0,3.3-0.7,4.5-1.9 l1.9-1.9L5.8,0.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "integrations-2-svg",
    d: "M10.9,0.8L8.4,3.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "integrations-2-svg",
    d: "M14.7,4.6l-2.5,2.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations2);
export default __webpack_public_path__ + "static/media/integrations-2.4681d2686655bf8f9a1962200259447b.svg";
export { ForwardRef as ReactComponent };